import React from 'react';

let Thankyou = () =>{
    return(
        <>
        </>
    )
}

export default Thankyou;